import { useState } from 'react';
import { Button } from '../../../../shared/components/button';
import {
  CardContainer,
  CardIconHeader,
} from '../../../../shared/components/card';
import { TextInput } from '../../../../shared/components/inputs';
import { Profile } from '../../models/profile';
import { DeleteUserRequest } from '../../infra/types/DeleteUserRequest.type';
import { useAppSelector } from '../../../../shared/infra/redux';

interface DeleteUserTemplateProps {
  onSubmit: (deleteRequest: DeleteUserRequest) => Promise<void>;
  profile: Profile | null;
}

export default function DeleteUserTemplate({
  profile,
  onSubmit,
}: DeleteUserTemplateProps): JSX.Element {
  const isLoading = useAppSelector(
    (state) => state.public.requestDeleteUserStatus.status,
  );
  const initialValue: DeleteUserRequest = {
    email: '',
    community_slug: profile ? profile.slug : '',
  };
  const [deleteRequest, setDeleteRequest] =
    useState<DeleteUserRequest>(initialValue);

  const handleOnInputChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = evt.target;
    setDeleteRequest({ ...deleteRequest, [name]: value.toLowerCase() });
  };

  const handleOnSubmit = async () => {
    await onSubmit(deleteRequest);
  };

  return (
    <CardContainer
      className='my-8 w-full rounded-lg bg-white shadow lg:my-0 xl:my-0'
      header={
        <CardIconHeader
          headerHeight='AUTO'
          icon={
            profile &&
            profile?.logo && (
              <div className='flex w-full flex-1 items-center justify-center pt-2'>
                <img
                  className='mx-auto h-28 w-28 max-w-full overflow-hidden rounded-xl object-contain'
                  src={profile.logo}
                  alt={`${profile.slug} logo small`}
                />
              </div>
            )
          }
          title='Delete Your App User'
          subtitle='Enter your email address to delete your user'
        />
      }
    >
      <form>
        <TextInput
          classes={['mb-10']}
          label='Email'
          placeholder='Email Address'
          name='email'
          onChange={handleOnInputChange}
        />
        <Button
          label='Request User Deletion'
          theme='PRIMARY'
          type='button'
          isLoading={isLoading === 'loading'}
          onClick={handleOnSubmit}
        />
      </form>
    </CardContainer>
  );
}
